var map = {
	"./assets/clickable/opensea.svg": "f16c195003c601ceacd8",
	"./assets/disabled/opensea.svg": "d6e6defd6afd92502ce0",
	"./assets/original/opensea.svg": "bfa1dddc3a46a1da305f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "65658d2a92d5596e3215";